<template>
	<div class="compary">
		<div class="page-tit">
			<span>修改企业资料</span>
		</div>
		<div class="compary-con">
			<div class="edit-form">
				<label>站神账号:</label>
				{{userInfo.username}}
			</div>
			<div class="edit-form">
				<label>公司全称:</label>
				{{userInfo.enterpriseName}}
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="98px" class="demo-ruleForm yq">
				<!-- <el-form-item label="公司全称：" prop="enterpriseName">
					<el-input v-model="ruleForm.enterpriseName" placeholder="请输入公司名全称，如深圳市单仁牛商络股份有限公司" ref="enterpriseName"></el-input>
					<i class="must">*</i>
				</el-form-item> -->
				<el-form-item label="公司LOGO：" class="edit-form edit-upload" prop="enterpriseLogoUrl">
					<div class="upload">
						<el-upload class="avatar-uploade" action="https://jsonplaceholder.typicode.com/posts/" :http-request="customUpload" :multiple="false" :show-file-list="false">
							<img v-if="ruleForm.enterpriseLogoUrl" :src="ruleForm.enterpriseLogoUrl" class="avatar" />
							<i v-else class="icon i-upload"></i>
						</el-upload>
					</div>
					<div style="display: inline-block;" class="upload-txt">
						<i class="must">*</i>
						<span style="padding-left: 8px;">(请上传jpg或png格式的图片)</span>
					</div>
					<el-input type="hidden" v-model="ruleForm.enterpriseLogoUrl"></el-input>
				</el-form-item>
				<el-form-item label="所属行业：" prop="enterpriseIndustry">
					<el-select v-model="ruleForm.enterpriseIndustry" multiple ref="enterpriseIndustry" placeholder="请选择行业">
						<el-option v-for="item in enterpriseType" :key="item.typeId" :label="item.label" :value="item.typeName"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="公司电话：" prop="enterpriseTelephone">
					<el-input v-model="ruleForm.enterpriseTelephone" placeholder="请输入公司电话" ref="enterpriseTelephone"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<el-form-item label="公司邮箱：" prop="enterpriseEmail">
					<el-input v-model="ruleForm.enterpriseEmail" placeholder="请输入公司邮箱" ref="enterpriseEmail"></el-input>
				</el-form-item>
				<el-form-item label="公司地址：" prop="enterpriseAddress">
					<el-input v-model="ruleForm.enterpriseAddress" placeholder="请输入公司地址" ref="enterpriseAddress"></el-input>
					<i class="must">*</i>
				</el-form-item>
				<h2 class="form-infos">*以下为联系人信息，方便您接收重要通知</h2>
				<el-form-item label="联系人：" prop="contactsName">
					<el-input v-model="ruleForm.contactsName" placeholder="请输入联系人" ref="contactsName"></el-input>
				</el-form-item>
				<el-form-item label="手机号：" prop="contactsMobile">
					<el-input v-model="ruleForm.contactsMobile" placeholder="请输入手机号" ref="contactsMobile"></el-input>
				</el-form-item>
				<el-form-item label="联系邮箱：" prop="contactsEmail">
					<el-input v-model="ruleForm.contactsEmail" placeholder="请输入联系邮箱" ref="contactsEmail"></el-input>
				</el-form-item>
			</el-form>
			<div class="formbtn ani" @click="submitForm('ruleForm')">保存</div>
			<ImgCropper v-if="showCropper" :newFileName="newFileName" :showCropper="showCropper" @closeCrop="closeCrop" :cropOptions="cropOptions"></ImgCropper>
			<!-- 提示 -->
			<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
		</div>
	</div>
</template>

<script>
import validate from '../../store/validate.js'
import rules from '../../store/rules.js'
import { mapState, mapGetters, mapActions } from 'vuex'
import Utils from '@/utils/utils.js'
import ImgCropper from '../Template/edit-template/component/ImgCroppre'
import mixinDialog from '@/mixins/mixinsDialog'

export default {
	name: 'companyInfo',
	components: {
		ImgCropper
	},
	data () {
		return {
			ruleForm: {
				// enterpriseName: '',
				enterpriseLogoUrl: '',
				enterpriseIndustry: [],
				enterpriseTelephone: '',
				enterpriseEmail: '',
				enterpriseAddress: '',
				contactsName: '',
				contactsMobile: '',
				contactsEmail: ''
			},
			rules: {
				...rules,
				enterpriseLogoUrl: [
					{ required: true, validator: validate.validateImg, trigger: 'change' }
				],
				enterpriseTelephone: [
					{ required: true, message: '公司电话不能为空', trigger: 'blur' },
					{ validator: validate.validatetelephone, trigger: 'blur' }
				],
				enterpriseAddress: [
					{ required: true, message: '公司地址不能为空', trigger: 'blur' },
					{ validator: validate.max200, trigger: 'blur' }
				],
				contactsMobile: [
					{ validator: validate.validatemphone, trigger: 'blur' }
				],
				enterpriseEmail: [
					{ validator: validate.validateemail, trigger: 'blur' },
					{ validator: validate.max100, trigger: 'blur' }
				],
				contactsEmail: [
					{ validator: validate.validateemail, trigger: 'blur' },
					{ validator: validate.max100, trigger: 'blur' }
				],
				contactsName: [
					{ validator: validate.max100, trigger: 'blur' }
					// ,{ validator: validate.enterpriseName, trigger: 'blur' }
				]
			},
			postData: {},
			showCropper: false,
			newFileName: '',
			cropOptions: {}
		}
	},
	mixins: [mixinDialog],
	created () {
		this.getInfos()
		if (this.enterpriseType.length === 0) {
			this.getEntpriseType()
		}
	},
	computed: {
		...mapGetters('user', ['userInfo']),
		...mapState('siteList', ['enterpriseType'])
	},
	methods: {
		...mapActions('user', [
			'getEnterpriseInfo',
			'postSaveEnterpriseInfo',
			'getUptoken',
			'getFrontUserInfo'
		]),
		...mapActions('siteList', ['getEntpriseType']),
		closeCrop (val) {
			this.showCropper = false
			this.ruleForm.enterpriseLogoUrl = val
		},
		customUpload (fielObj) {
			let file = fielObj.file
			if (!/(image\/jpeg)|(image\/png)/.test(file.type)) {
				this.openErrDialog('warn', '操作信息提示', '', '', '必需为png或jpg图片类型', '确定')
				return
			}
			// 大小不允许超过30M
			let imgSize = file.size
			if (imgSize > 30 * 1024 * 1024) {
				this.openImgErrDialog('warn', '操作信息提示', '', '', '图片大小不能大于30M', '确定')
				return
			}
			this.getNewFileName(file)
			if (typeof FileReader === 'function') {
				const reader = new FileReader()
				reader.onload = (e) => {
					let base64 = e.target.result
					let upImage = new Image()
					upImage.src = base64
					upImage.onload = () => {
						this.cropOptions = {
							cropLawImg: base64,
							upImageHeight: upImage.height,
							upImageWidth: upImage.width,
							wSize: upImage.height,
							hSize: upImage.width,
							file: file,
							islogo: true,
							fname: file.name
						}
						this.showCropper = true
					}
				}
				reader.readAsDataURL(file)
			} else {
				this.openErrDialog('warn', '操作信息提示', '', '', '浏览器不支持，请更换浏览器后重试', '确定')
			}
		},
		getNewFileName (file) {
			let fileExtName = /\.[^\.]+$/.exec(file.name)[0]
			let imgName = fileExtName === '.ico' ? 'favicon' : new Date().getTime()
			this.newFileName = `images/${imgName}${fileExtName}`
		},
		submitForm (formName) {
			this.$refs[formName].validate((valid, data) => {
				if (valid) {
					this.postInfos()
				} else {
					for (let x in data) {
						if (x === 'enterpriseLogoUrl')
							document.documentElement.scrollTop = document.body.scrollTop = 0
						this.$refs[x].focus()
						return
					}
					return false
				}
			})
		},
		//提交修改
		postInfos () {
			this.ruleForm.enterpriseName = this.ruleForm.enterpriseName.replace(/(^\s*)|(\s*$)/g, '')
			this.postSaveEnterpriseInfo(this.ruleForm).then(res => {
				if (res.data.isSuccess) {
					this.getFrontUserInfo() //更新vuex
					this.$message({
						message: '企业信息修改成功',
						type: 'success'
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		},
		//获取公司信息
		getInfos () {
			this.getEnterpriseInfo().then(res => {
				if (res.data.isSuccess) {
					const data = res.data.data
					this.ruleForm = {
						enterpriseName: data.enterpriseName ? data.enterpriseName : '',
						enterpriseLogoUrl: data.enterpriseLogoUrl ? data.enterpriseLogoUrl : '',
						enterpriseIndustry: data.enterpriseIndustry ? data.enterpriseIndustry : [],
						enterpriseTelephone: data.enterpriseTelephone ? data.enterpriseTelephone : '',
						enterpriseEmail: data.enterpriseEmail ? data.enterpriseEmail : '',
						enterpriseAddress: data.enterpriseAddress ? data.enterpriseAddress : '',
						contactsName: data.contactsName ? data.contactsName : '',
						contactsMobile: data.contactsMobile ? data.contactsMobile : this.userInfo.moblie,
						contactsEmail: data.contactsEmail ? data.contactsEmail : ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
			})
		}
	}
}

</script>


<style lang="scss" scoped>
.edit-form {
	position: relative;
	width: 685px;
	margin-bottom: 29px;
	label {
		display: inline-block;
		width: 98px;
		text-align: right;
		padding-right: 12px;
	}
}
.compary-con{
	background:rgba(255,255,255,1);
	border-radius:4px;
	padding: 34px 70px;

}

.form-infos {
	width:517px;
	border-top: 1px solid #CAD2ED;
	margin-top: 49px;
	padding-top: 34px;
	color: $colorD;
	font-size: 14px;
	font-weight: normal;
	line-height: 14px;
}

.formbtn {
	margin: 30px 0 44px 98px;
}

.upload {
	position: relative;
	display: inline-block;
	width: 120px;
	height: 120px;
	border-radius:8px;
	border: 1px dashed #A1ABD5;
	border-radius: 3px;
	vertical-align: top;
	cursor: pointer;

	i {
		display: block !important;
		margin: 40px auto 0 !important;
	}
}

.upload-txt{
	span{font-size: 12px;
	color: #8392A4;}
}
.edit-upload {
	font-size: 0;

	label {
		line-height: 40px;
		vertical-align: top;
		font-size: 14px;
	}

	i {
		line-height: 120px;
	}
}

.el-input {
	width: 420px;
}

.el-select {
	display: inline-block;
	width: 420px;
}

i.must {
	display: inline-block;
	margin-left: 20px;
	color: #e80000;
	font-size: 14px;
}

.avatar-uploader {
	display: inline-block;
	position: relative;
	width: 95px;
	height: 95px;
	border: 1px solid #dcdfe6;
	border-radius: 3px;
	vertical-align: top;
	cursor: pointer;
	overflow: hidden;

	i {
		display: block !important;
		margin: 28px auto 0 !important;
	}

	&.err {
		border: 1px solid #f56c6c;
	}
}

.avatar {
	max-width: 93px;
	max-height: 93px;
	display: inline-block;
	vertical-align: middle;
}

.el-form-item__error {
	left: 88px;
}
</style>
